<template>
  <div>
    <Card v-for="(item, index) in data" :key="index" class="card-with-radius">
      <v-layout row wrap>
        <v-flex xs6 py-2 px-4>
          <span class="head">{{ item.plant_name }}</span>
        </v-flex>
        <v-flex xs6 py-2 text-right>
          <span>{{ item.location }}</span>
        </v-flex>

        <v-flex xs6 py-2 px-4>
          <div class="label">
            AC Capacity: <span class="number--text">{{ item.ac_capacity }}</span>
          </div>
        </v-flex>
        <v-flex xs6 py-2>
          <div class="label">
            Energy Today(kWh):
            <span :class="item.generation ? 'number--text' : 'error--text'">
              {{ item.generation || "NO DATA" }}
            </span>
          </div>
        </v-flex>

        <v-flex xs6 py-2 px-4>
          <div class="label">
            AC Power(kWp):
            <span :class="item.power ? 'number--text' : 'error--text'">
              {{ item.power || "NO DATA" }}</span>
          </div>
        </v-flex>
        <v-flex xs6 py-2>
          <div class="label">
            PR(%):
            <span :class="item.ratio ? 'number--text' : 'error--text'">
              {{ item.ratio || "NO DATA" }}</span>
          </div>
        </v-flex>
      </v-layout>

      <v-flex xs12>
        <div class="alerts">
          <span v-for="(value, key) in item.alert" v-bind:key="key">
            <AlertIndicator :alertTag="alertShorthand(key)" :tip="key.toUpperCase()" :alert="value === 'alert'" @click="
              $emit('alert-action', {
                plantId: item.plant_id,
                alert: key,
              })
              "></AlertIndicator>
          </span>
        </div>
      </v-flex>
    </Card>
  </div>
</template>

<script>
import { mapMutations, mapActions } from "vuex";
import { mixin } from "@/util/mixin/index";
import AlertIndicator from "@/components/home/DataTable/AlertIndicator";
import Card from "@/components/common/Cards.vue";

export default {
  props: {
    data: {
      type: Array,
      default: () => [],
    },
  },
  mixins: [mixin],
  components: {
    AlertIndicator,
    Card,
  },
  methods: {
    ...mapActions(["fetchActivePlantDetails"]),
    alertShorthand(device) {
      return device.charAt(0).toUpperCase();
    },
    async redirectAlert(plantId) {
      await this.fetchActivePlantDetails(plantId);
      this.$router.push({ name: "alert" });
    },
  },
};
</script>

<style>
.alerts {
  display: flex;
  justify-content: center;
  align-items: center;
}

.status-btn {
  width: 20px !important;
  height: 20px !important;
  /* margin: 6px 3px; */
}

.label {
  font-size: 12px;
  font-weight: normal;
  color: var(--v-extraGrey-base);
}

.card-with-radius {
  border-radius: 10px;
  margin-bottom: 16px;
  box-shadow: 1px 2px 2px rgba(126, 158, 247, 0.418);
  padding-top: 5px;
}
</style>
